// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_2hm10","full-rotation":"_29Ock","light":"_23C8g"};